<template>
    <div class="video-player-container" :style="containerStyle">
        <!-- Iframe integration method only -->
        <iframe
            :src="`https://www.nanoo.tv/link/w/${clientId}`"
            frameborder="0"
            allow="autoplay; fullscreen"
            allowfullscreen
            scrolling="no"
            sandbox="allow-scripts allow-same-origin allow-popups allow-popups-to-escape-sandbox allow-storage-access-by-user-activation"
            class="video-player-iframe"
            :style="iframeStyle"
        ></iframe>
    </div>
</template>

<script lang="ts">
    import { defineComponent, computed, watch, onMounted } from 'vue'
    import { useMediaStore } from '@/utils/useMediaStore'

    export default defineComponent({
        name: 'VideoPlayer',

        props: {
            clientId: {
                type: String,
                required: true,
            },
            width: {
                type: [String, Number],
                default: '100%',
            },
            height: {
                type: [String, Number],
                default: '480px',
            },
            config: {
                type: Object,
                default: () => ({}),
            },
        },

        emits: ['playbackStarted'],

        setup(props, { emit }) {
            const mediaStore = useMediaStore()

            // Computed styles
            const containerStyle = computed(() => ({
                width: typeof props.width === 'number' ? `${props.width}px` : props.width,
                height: typeof props.height === 'number' ? `${props.height}px` : props.height,
            }))

            const iframeStyle = computed(() => ({
                width: '100%',
                height: '100%',
            }))

            // Watch for changes to clientId
            watch(
                () => props.clientId,
                () => {
                    // Update store
                    mediaStore.playVideo(props.clientId)
                }
            )

            // Initialize on component mount
            onMounted(() => {
                // Update store
                mediaStore.playVideo(props.clientId)

                // Emit event when playback starts
                emit('playbackStarted')
            })

            return {
                containerStyle,
                iframeStyle,
            }
        },
    })
</script>

<style scoped>
    .video-player-container {
        position: relative;
        overflow: hidden;
        background-color: #000;
        border-radius: 4px;
    }

    .video-player-iframe {
        border: none;
    }

    .player-controls {
        margin-top: 16px;
        padding: 8px;
        background-color: #f5f5f5;
        border-radius: 4px;
        display: flex;
        flex-wrap: wrap;
        gap: 16px;
        align-items: center;
    }
</style>

<style>
    /* To ensure the NanooPlayer is styled correctly */
    .nanoo-player {
        width: 100%;
        height: 100%;
    }
</style>
